import { Form, Input } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../components/DraggableModal";
import { SelectMultiAtimalTypeSingle } from "../../../components/selects";
import { EntPopulation } from "../../../models/population";

enum FormField {
  count,
  animalTypeIds,
  areaId
}

interface IProps {
  show: boolean;
  population: EntPopulation;
  onHide: () => void;
  onSubmit: (pos: EntPopulation) => Promise<boolean>;
}

export const AddPopulationModal = (props: IProps) => {
  const { t } = useTranslation();
  const [ form ] = useForm();
  const [ loading, setLoading ] = useState<boolean>(false);


  const setFieldsFromEntity = (): void => {
	const animalTypes = props.population.animalTypes
	  ? props.population.animalTypes.map(animalType => animalType.id) : [];
	form.setFields([
	  { name: FormField.count, value: props.population.count },
	  { name: FormField.animalTypeIds, value: animalTypes },
	  { name: FormField.areaId, value: props.population.area?.id },
	]);
  }
  useEffect(() => {
	if (props.show) setFieldsFromEntity();
  }, [ props.show ]);
  const setEntityFromFields = (): EntPopulation => {
	let population = _.cloneDeep(props.population);
	population.id = props.population.id;
	population.count = form.getFieldValue(FormField.count);
	population.animalTypeIds = form.getFieldValue(FormField.animalTypeIds);
	population.areaId = form.getFieldValue(FormField.areaId);
	return population;
  }

  const handleSubmit = async () => {
	setLoading(true);
	try {
	  await form.validateFields();
	  const data = setEntityFromFields();
	  const result = await props.onSubmit(data);
	  if (result) props.onHide();
	} finally {
	  setLoading(false);
	}
  }

  return (
	<>
	  <DraggableModal
		title={ props.population.id === 0 ? t('population.add_population') : t('population.edit_population') }
		visible={ props.show }
		onCancel={ props.onHide }
		onSubmit={ handleSubmit }
		submitLoading={ loading }
	  >
		<Form
		  initialValues={ { remember: true } }
		  autoComplete="off"
		  layout="vertical"
		  form={ form }
		>

		  <Form.Item
			label={ t('breeding_farms.quantity') }
			name={ FormField.count }
		  >
			<Input autoComplete="off"/>
		  </Form.Item>

		  <Form.Item
			label={ t('population.animal_type_population') }
			name={ FormField.animalTypeIds }
		  >
			<SelectMultiAtimalTypeSingle/>
		  </Form.Item>
		</Form>
	  </DraggableModal>

	</>

  )
}
